import React from 'react';
import { motion } from 'framer-motion';
import { Music, Users, Heart, Baby, Mic, BookOpen, Crown, Handshake } from 'lucide-react';

const Ministerios = () => {
  const ministerios = [
    {
      titulo: 'Louvor e Adoração',
      descricao: 'Ministério dedicado a conduzir a igreja em momentos de adoração genuína através da música.',
      icon: Music,
      cor: 'from-[#030B2E] to-[#17E6B3]',
      responsavel: 'Ministério de Música',
      atividades: [
        'Ensaios semanais',
        'Ministração nos cultos',
      
      ]
    },
    {
      titulo: 'Jovens MEVAM',
      descricao: 'Ministério focado no desenvolvimento espiritual, social e emocional dos jovens.',
      icon: Users,
      cor: 'from-[#17E6B3] to-[#030B2E]',
      responsavel: 'Liderança Jovem',
      atividades: [
        'Encontros quinzenais',
        'Acampamentos e retiros',
        'Evangelismo jovem',
        'Discipulado específico'
      ]
    },
    {
      titulo: 'Intercessão',
      descricao: 'Grupo de oração dedicado à intercessão pela igreja, cidade e nação.',
      icon: Heart,
      cor: 'from-[#030B2E] via-[#17E6B3]/50 to-[#030B2E]',
      responsavel: 'Equipe de Intercessão',
      atividades: [
        'Vigílias de oração',
        'Intercessão pelos cultos',
        'Oração pelas famílias',
        'Jejuns coletivos'
      ]
    },
    {
      titulo: 'Ministério Infantil',
      descricao: 'Cuidado e ensino bíblico para as crianças com criatividade e amor.',
      icon: Baby,
      cor: 'from-[#17E6B3]/90 to-[#030B2E]',
      responsavel: 'Liderança Infantil',
      atividades: [
        'Escola Bíblica Infantil',
        'Atividades lúdicas',
         'Eventos especiais'
      ]
    },
    {
      titulo: 'Ministério de Mídia',
      descricao: 'Responsável pela transmissão, som, imagem e comunicação da igreja.',
      icon: Mic,
      cor: 'from-[#030B2E] to-[#17E6B3]/80',
      responsavel: 'Liderança de Mídia ',
      atividades: [
        'Transmissões ao vivo',
        'Produção de conteúdo',
        'Sonorização dos cultos',
        'Redes sociais'
      ]
    },
    {
      titulo: 'MEVAM Academy',
      descricao: 'Ensino sistemático e aprofundado da Palavra de Deus para todas as idades.',
      icon: BookOpen,
      cor: 'from-[#17E6B3] to-[#030B2E]/90',
      responsavel: 'Professores do MEVAM Global',
      atividades: [
        'Aulas as terças-feiras',
        'Cursos especiais',
        'Material didático',
        'Certificações'
      ]
    },
    {
      titulo: 'Ministério de Diaconia',
      descricao: 'Serviço prático de apoio às necessidades da igreja e comunidade.',
      icon: Handshake,
      cor: 'from-[#030B2E]/95 to-[#17E6B3]',
      responsavel: 'Diáconos',
      atividades: [
        'Apoio aos necessitados',
        'Organização dos cultos',
        'Recepção e hospitalidade',
        'Ação social'
      ]
    },
    {
      titulo: 'Ministério da Família',
      descricao: 'Fortalecimento dos vínculos familiares e matrimoniais através de ensino bíblico e aconselhamento.',
      icon: Crown,
      cor: 'from-[#17E6B3]/70 to-[#030B2E]',
      responsavel: 'Líderes de Casais',
      atividades: [
        'Encontros de casais',
        'Aconselhamento familiar',
        
        'Eventos familiares'
      ]
    },
    {
      titulo: 'Ministério de Acolhimento',
      descricao: 'Recepção calorosa e acolhimento de todos que chegam à igreja, criando um ambiente de amor e hospitalidade.',
      icon: Heart,
      cor: 'from-[#17E6B3]/80 to-[#030B2E]',
      responsavel: 'Equipe de Acolhimento',
      atividades: [
        'Recepção nos cultos',
        'Integração de novos membros',
        'Ministração de boas-vindas',
        'Apoio aos visitantes'
      ]
    }
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="section-padding bg-gradient-to-br from-[#030B2E] via-[#030B2E] to-[#17E6B3]/20 text-white">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Nossos Ministérios
            </h1>
            <p className="text-xl md:text-2xl text-[#B8C4E3]">
              Descubra como você pode servir e crescer espiritualmente em nossa comunidade de fé
            </p>
          </motion.div>
        </div>
      </section>

      {/* Ministérios Grid */}
      <section className="section-padding bg-[#030B2E]">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Encontre Seu Lugar de Serviço
            </h2>
            <p className="text-[#B8C4E3] text-lg max-w-3xl mx-auto">
              Cada ministério é uma oportunidade de crescer espiritualmente enquanto serve ao Reino de Deus. 
              Descubra onde seus dons e talentos podem fazer a diferença.
            </p>
          </motion.div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {ministerios.map((ministerio, index) => {
              const IconComponent = ministerio.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="bg-white rounded-xl overflow-hidden hover:shadow-2xl hover:shadow-[#17E6B3]/20 transition-all duration-300 group"
                >
                  {/* Header com Gradiente */}
                  <div className={`bg-gradient-to-r ${ministerio.cor} p-6 text-white`}>
                    <IconComponent className="w-12 h-12 mb-4 mx-auto" />
                    <h3 className="text-xl font-bold text-center mb-2">
                      {ministerio.titulo}
                    </h3>
                    <p className="text-center text-sm opacity-90">
                      {ministerio.responsavel}
                    </p>
                  </div>
                  
                  {/* Conteúdo */}
                  <div className="p-6">
                    <p className="text-gray-600 mb-6">
                      {ministerio.descricao}
                    </p>
                    
                    <div className="space-y-3">
                      <h4 className="font-semibold text-[#030B2E] mb-3">
                        Principais Atividades:
                      </h4>
                      <ul className="space-y-2">
                        {ministerio.atividades.map((atividade, actIndex) => (
                          <li key={actIndex} className="flex items-center text-sm text-gray-600">
                            <div className="w-2 h-2 bg-[#17E6B3] rounded-full mr-3 flex-shrink-0"></div>
                            {atividade}
                          </li>
                        ))}
                      </ul>
                    </div>
                    
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      className="w-full mt-6 bg-[#17E6B3] hover:bg-[#17E6B3]/90 text-[#030B2E] py-3 px-4 rounded-lg font-semibold transition-colors duration-300 shadow-lg shadow-[#17E6B3]/30"
                    >
                      Quero Participar
                    </motion.button>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Como Participar */}
      <section className="section-padding bg-[#030B2E]">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Como Participar dos Ministérios
              </h2>
              <p className="text-[#B8C4E3] text-lg">
                Passos simples para começar a servir e crescer em nossa comunidade
              </p>
            </motion.div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-center"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#17E6B3] to-[#17E6B3]/70 text-[#030B2E] rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold shadow-lg shadow-[#17E6B3]/30">
                  1
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">
                  Converse Conosco
                </h3>
                <p className="text-[#B8C4E3]">
                  Fale com um de nossos líderes após o culto ou entre em contato conosco. 
                  Queremos conhecer você e seus dons.
                </p>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
                viewport={{ once: true }}
                className="text-center"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#17E6B3] to-[#17E6B3]/70 text-[#030B2E] rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold shadow-lg shadow-[#17E6B3]/30">
                  2
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">
                  Participe dos Encontros
                </h3>
                <p className="text-[#B8C4E3]">
                  Venha aos encontros e atividades do ministério que deseja participar. 
                  Conheça a equipe e entenda melhor o propósito.
                </p>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                viewport={{ once: true }}
                className="text-center"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#17E6B3] to-[#17E6B3]/70 text-[#030B2E] rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold shadow-lg shadow-[#17E6B3]/30">
                  3
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">
                  Comece a Servir
                </h3>
                <p className="text-[#B8C4E3]">
                  Inicie gradualmente no ministério, recebendo capacitação e mentoria 
                  dos líderes mais experientes.
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section-padding bg-gradient-to-br from-[#030B2E] to-[#17E6B3]/20 text-white">
        <div className="container-custom text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Deus Tem Um Lugar Para Você
            </h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto text-[#B8C4E3]">
              Cada pessoa tem dons únicos dados por Deus. Descubra como seus talentos 
              podem ser usados para edificar vidas e expandir o Reino de Deus.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <motion.a
                href="/contato"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-[#17E6B3] hover:bg-[#17E6B3]/90 text-[#030B2E] font-semibold py-3 px-8 rounded-xl transition-all inline-flex items-center justify-center shadow-lg shadow-[#17E6B3]/30"
              >
                <Heart className="mr-2" size={20} />
                Quero Servir
              </motion.a>
              <motion.a
                href="tel:61999999999"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="border-2 border-white text-white hover:bg-white hover:text-[#030B2E] font-semibold py-3 px-8 rounded-xl transition-all inline-flex items-center justify-center"
              >
                <Users className="mr-2" size={20} />
                Falar com Liderança
              </motion.a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Ministerios;